import ServicesConfig from '@/config/ServicesConfig';
import Axios from 'axios';
export default {
    uploadFile(formData) {
        return Axios.post(ServicesConfig.FILES.UPLOAD_FILE, formData, {
            headers: {
                "content-type": "multipart/form-data"
            }
        })
    }
}